export default function initModal() {
  function hideModal(modalElement) {
    const modalId = modalElement.getAttribute("id");
    document.documentElement.classList.remove("modal-open");
    modalElement.classList.remove("is-visible");
    document
      .querySelectorAll(`[data-modal=${modalId}]`)
      .forEach((item) => item.classList.remove("is-open"));
  }

  function showModal(modalElement) {
    document.documentElement.classList.add("modal-open");
    modalElement.classList.add("is-visible");
  }

  const modals = document.querySelectorAll(".modal");
  const modalTriggers = document.querySelectorAll("[data-modal]");
  if (!modals.length || !modalTriggers.length) {
    return;
  }
  modals.forEach((modal) => {
    modal.addEventListener(
      "click",
      (e) => {
        if (e.target.closest(".modal-close")) {
          e.preventDefault();
          e.stopImmediatePropagation();
          hideModal(modal);
        }
      },
      false
    );
  });

  document.addEventListener('keydown', e => {
    if(e.key === "Escape") {
      modals.forEach((modal) => {
        hideModal(modal);
      });
    }
  }, false);

  modalTriggers.forEach((modalTrigger) => {
    modalTrigger.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        const modalElement = document.getElementById(
          modalTrigger.dataset.modal
        );
        const isModalVisible = modalElement.classList.contains("is-visible");
        if (!isModalVisible) {
          showModal(modalElement);
          modalTrigger.classList.add("is-open");
        } else {
          hideModal(modalElement);
        }
      },
      false
    );
  });
}
